export const enumTypeNotification = {
  CAMPAIGN: 'CAMPAIGN_ACTIVITY',
  ORDER: 'ORDER_ACTIVITY',
};
